export default '/build/078706cf.jpg'